export enum ROLES {
    SYS_ADMIN = 'SysAdmin',
    ADMIN = 'Admin',
    DEVELOPER = 'Regular',
    STUDENT = 'Student',
    TEACHER = 'Teacher',
    VIEWER = 'Viewer',
}
